import {
  Breadcrumb,
  Button,
  message,
  PageHeader,
  Form,
  Table,
  Modal,
  Checkbox,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { jobService } from "_services";
import TabMenu from "./TabMenu";

function Task({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState({});
  const [tasks, setTasks] = useState([]);
  const [form] = Form.useForm();
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState([]);
  const [
    selectedEmployeesForSelectedTask,
    setSelectedEmployeesForSelectedTask,
  ] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setIsLoading(true);
    jobService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setItem(x.content);
        const allTasks = x.content.workItems.flatMap((workItem) =>
          workItem.jobTasks.map((task) => ({
            ...task,
            workItem: workItem,
          }))
        );
        setTasks(allTasks);
        setSelectedEmployees(x.content.employees);
        onFill(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const onCancel = () => {
    history.push("/jobs");
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const onCheck = (checkedValues) => {
    setSelectedEmployeesForSelectedTask(checkedValues);
  };

  const onClickTask = (task) => {
    const alreadySelectedEmployeeList = task?.employees.map(
      (singleEmployee) => {
        return singleEmployee?.id;
      }
    );
    setSelectedTask(task);
    setSelectedEmployeesForSelectedTask(alreadySelectedEmployeeList);
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setSelectedEmployeesForSelectedTask([]);
    setSelectedTask();
    setIsModalOpen(false);
  };

  const handleModalOk = () => {
    setIsLoading(true);
    if (selectedEmployeesForSelectedTask.length > 0) {
      const modifiedSelectedEmployeeList = selectedEmployeesForSelectedTask.map(
        (singleEmployee) => {
          return { id: singleEmployee };
        }
      );
      const payload = {
        ...selectedTask,
        employees: modifiedSelectedEmployeeList,
      };
      jobService
        .updateJobTask(selectedTask.id, item.id, payload)
        .then((x) => {
          getData();
          handleModalCancel();
        })
        .catch((error) => {
          message.error(`${error}`);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      handleModalCancel();
    }
  };

  const employeeTableColumns = [
    {
      title: "Select employee",
      dataIndex: "selectEmployee",
      width: "10%",
      render: (text, record) => <Checkbox value={record.id}></Checkbox>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name,
    },
    {
      title: "NIC",
      dataIndex: "nic",
      key: "nic",
      render: (text, record) => record.nic ?? "",
    },
    {
      title: "Total Booked Mins",
      dataIndex: "totalBookedMins",
      key: "totalBookedMins",
      render: (text, record) => record.totalBookedMins ?? "-",
    },
    {
      title: "Total Labour Cost",
      dataIndex: "totalLabourCost",
      key: "totalLabourCost",
      render: (text, record) => record.totalLabourCost ?? "-",
    },
  ];

  const getTaskColumns = () => {
    const lineColumns = [];
    lineColumns.push({
      title: "Task No",
      dataIndex: "code",
      key: "code",
      render: (text, record) => (
        <Button
          onClick={() => onClickTask(record)}
          disabled={selectedEmployees?.length <= 0}
          type="link"
        >
          {record.code}
        </Button>
      ),
    });
    lineColumns.push({
      title: "Task Description",
      dataIndex: "name",
      key: "name",
    });
    lineColumns.push({
      title: "Work Item",
      dataIndex: "workItem.code",
      key: "workItemCode",
    });
    lineColumns.push({
      title: "Product",
      dataIndex: "workItem.material.code",
      key: "productCode",
    });

    return lineColumns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Job : {item.code}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Tasks</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="tasks" id={id} />
          {tasks.length > 0 && (
            <Table
              bordered
              pagination={false}
              columns={getTaskColumns()}
              dataSource={tasks}
            />
          )}

          <Modal
            title="Select task recourses"
            open={isModalOpen}
            width={720}
            onCancel={handleModalCancel}
            onOk={handleModalOk}
          >
            <Checkbox.Group
              style={{ width: "100%" }}
              onChange={onCheck}
              value={selectedEmployeesForSelectedTask}
            >
              <Table
                bordered
                loading={isLoading}
                rowKey="id"
                size="small"
                columns={employeeTableColumns}
                dataSource={selectedEmployees}
              />
            </Checkbox.Group>
          </Modal>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Task;
